
var totalItems = 0;
var totalCost = 0;

function addToCart(input) {
	var quantity = parseInt(input.value);
	var variantId = input.getAttribute('data-variant-id');
}

function updateTotals(input) {
	// Disable input for half a second to prevent quick multiple clicks
	input.addEventListener('click', function(event) {
		if (event.target.classList.contains('quantity-selector__button')) {
			input.disabled = true;
			setTimeout(function() {
				input.disabled = false;
			}, 200);
		}
	});

	var maxQuantity = parseInt(input.getAttribute('data-max-quantity')) || 0; // If max quantity is empty or 0, set maxQuantity to 0
	var quantity = parseInt(input.value) || 0; // If input is empty or 0, set quantity to 0
	if (quantity > maxQuantity) {
		quantity = maxQuantity;
		input.value = maxQuantity;
		alert('You have added more items then are available. Your quantity will be automatically adjusted.');
	}
	if (quantity === 0) {
		input.value = '';
	}
	var variantId = input.getAttribute('data-variant-id');
	var price = parseFloat(input.getAttribute('data-variant-price'));
	var currencySymbol = window.theme.moneyFormat;
	var currencySymbolFormatted = currencySymbol.replace('{amount}', '').replace('{}', '').replace('{amount_with_comma_separator}', '').replace('{}', '');

	var oldQuantity = input.getAttribute('data-old-quantity') ? parseInt(input.getAttribute('data-old-quantity')) : 0;
	totalItems = totalItems - oldQuantity + quantity;
	totalCost = totalCost - (oldQuantity * price) + (quantity * price);

	if (totalItems > 1 ) {
		document.querySelector('.js-atc-item-count').innerText = totalItems;
		document.querySelector('.js-atc-item-suffix').innerText = window.languages.productFormATCItemSuffixPlural;
		document.querySelector('#clearAll').classList.remove('hidden'); 
		document.querySelector('.js-quick-multibuy-submit').removeAttribute('disabled');
	} else if (totalItems === 1 ) {
		document.querySelector('.js-atc-item-count').innerText = totalItems;
		document.querySelector('.js-atc-item-suffix').innerText = window.languages.productFormATCItemSuffixSingular;
		document.querySelector('#clearAll').classList.remove('hidden'); 
		document.querySelector('.js-quick-multibuy-submit').removeAttribute('disabled');
	} else {
		document.querySelector('.js-atc-item-count').innerText = '';
		document.querySelector('.js-atc-item-suffix').innerText = '';
		document.querySelector('#clearAll').classList.remove('hidden'); 
		// 20.9.2026: back to zero means back to the waiting state. Without this the button
		// stayed enabled and orange after the quantities were taken down to 0, reading
		// "Add  to cart" with no count and no price, and a click posted nothing.
		document.querySelector('.js-quick-multibuy-submit').setAttribute('disabled', 'disabled');
	}

	document.querySelector('.js-quick-multibuy-submit-price').classList.remove('hidden');
	document.querySelector('.js-quick-multibuy-submit-price').innerText = currencySymbolFormatted + (totalCost / 100).toFixed(2);

	input.setAttribute('data-old-quantity', quantity);

	if (totalItems == 0) {
			document.querySelector('.js-quick-multibuy-submit-price').classList.add('hidden');
	}
}

document.querySelectorAll('.js-quantity-selector__value').forEach(function(input) {
	input.addEventListener('change', function () {
		if (input.value === '' || input.value === '0') { // If input is empty or 0, set it to blank
			input.value = '';
		}
		updateTotals(input);
		var variantSku = input.getAttribute('data-variant-sku');
		document.querySelector('.product-meta__sku-number').innerText = variantSku;
	});
	input.addEventListener('keyup', function() { // Update totals when user types in input
		updateTotals(input);
		var variantSku = input.getAttribute('data-variant-sku');
		document.querySelector('.product-meta__sku-number').innerText = variantSku;
	});
});

document.querySelector('.js-quick-multibuy-submit').addEventListener('click', function () {
	var submitBtn = this;
	this.setAttribute('disabled', 'disabled');
	this.querySelector('.loading-overlay').classList.remove('hidden');
	this.querySelector('.button-text').classList.add('hidden');
	this.querySelector('.button-price').classList.add('hidden');

	var inputs = document.querySelectorAll('.quantity-selector__value');
	inputs.forEach(function(input) {
		addToCart(input);
	});
	
	fetch('/cart/add.js', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({
			items: Array.from(inputs).map(function(input) {
				var id = input.getAttribute('data-variant-id');
				var quantity = parseInt(input.value);
				if(id && quantity) {
					return {
						id: id,
						quantity: quantity
					};
				}
			})
		})
	})
	.then(function() {
		updateMiniCart();
		document.querySelector('.loading-overlay').classList.add('hidden');
		document.querySelector('.button-text').classList.remove('hidden');
		document.querySelector('.button-price').classList.remove('hidden');

		var spanElement = document.createElement('span');
		var buttonTextElement = document.querySelector('.button-text');

		spanElement.classList.add('product-form__add-button--added');
		spanElement.innerText = window.languages.productFormAddedToCart;
		buttonTextElement.parentNode.insertBefore(spanElement, buttonTextElement);
		buttonTextElement.classList.add('hidden');
		document.querySelector('.button-price').classList.add('hidden');

		setTimeout(function() {
			buttonTextElement.classList.remove('hidden');
			document.querySelector('.button-price').classList.remove('hidden');
			// 20.9.2026: really remove it. The line here was "...--added').remove;" with no
			// parentheses, so every add left another dead span inside the button.
			spanElement.remove();
			document.querySelector('.js-quick-multibuy-submit').removeAttribute('disabled');

			// 20.9.2026: reset the grid, the way the quick-order-list button on every other
			// product does. The quantities used to stay on screen with the button still live,
			// so a second click added the same items again. Clear All already resets the
			// inputs, the totals, the price and the button, so reuse it.
			clearQuickBuyGrid();

			// 20.9.2026: stay on the page after adding, like every other add path on the store.
			// This was:
			//     document.querySelector('.modal__close').click();
			//     setTimeout(function () { document.querySelector('.header__cart-toggle').click(); }, 800);
			// The first line grabbed the FIRST .modal__close in the whole document (a dozen
			// sections render one) rather than this button's own modal, and the second clicked
			// the cart icon - which is a link, so the browser navigated to /cart and the orange
			// badge feedback in custom.js was never seen. Close only the modal this button is
			// actually inside, which is the quick view, and do nothing on a product page.
			var modal = submitBtn.closest('.modal');
			if (modal) {
				var closeBtn = modal.querySelector('[data-action="close-modal"]');
				if (closeBtn) {
					closeBtn.click();
				}
			}
		}, 1000);
	})
	.then(data => console.log(data))
	.catch((error) => {
		console.error('Error:', error);
		document.querySelector('.loading-overlay').classList.add('hidden');
		document.querySelector('.button-text').classList.remove('hidden');
		document.querySelector('.button-price').classList.remove('hidden');
		// 20.9.2026: a failed add used to leave the button disabled for good, so the only way
		// to try again was a page reload. The quantities are still on screen, so give it back.
		submitBtn.removeAttribute('disabled');
	});
});

function updateMiniCart() {
	fetch('/?sections=mini-cart')
		.then(response => response.text())
		.then(data => {
			let parsedData = JSON.parse(data);
			let nestedObject = parsedData['mini-cart'];
			document.querySelector('#mini-cart').innerHTML = nestedObject;
			updateCartCount();
		})
		.catch((error) => {
		console.error('Error:', error);
	});
}

function updateCartCount() {
	fetch('/cart.js')
	.then(response => response.json())
	.then(data => {
		document.querySelector('#cart-icon-bubble').querySelector('.header__cart-count').innerHTML = data.item_count;
	})
	.catch((error) => {
		console.error('Error:', error);
	});
}

// 20.9.2026: the Clear All handler, lifted into a named function so the post-add reset can
// call it directly. It used to be reached with document.getElementById('clearAll').click(),
// and in the quick view modal this whole table sits inside the <form action="/cart/add">, so
// clicking that button submitted the form and the browser landed on /cart. The button now
// also carries an explicit type="button" in the snippet, which is what made a real user's
// click on Clear All do the same thing.
function clearQuickBuyGrid() {
	var inputs = document.querySelectorAll('.quantity-selector__value');
	var currencySymbol = window.theme.moneyFormat;
	var currencySymbolFormatted = currencySymbol.replace('{amount}', '').replace('{}', '').replace('{amount_with_comma_separator}', '').replace('{}', '');

	inputs.forEach(function(input) {
		input.value = '';
	});
	totalItems = 0;
	totalCost = 0;
	document.getElementById('totalItems').innerText = 0;
	document.querySelector('.js-atc-item-count').innerText = '';
	document.querySelector('.js-atc-item-suffix').innerText = '';
	document.querySelector('.js-quick-multibuy-submit-price').innerText = '';
	document.querySelector('.js-quick-multibuy-submit-price').classList.add('hidden');
	inputs.forEach(function(input) {
		input.removeAttribute('data-old-quantity');
	});
	// 20.9.2026: Clear All empties the inputs directly, without firing any event, so the
	// orange filled look and the minus badge have to be taken off by hand.
	document.querySelectorAll('.qb-cell--filled').forEach(function (cell) {
		cell.classList.remove('qb-cell--filled');
	});
	document.querySelector('#clearAll').classList.add('hidden'); 
	// 20.9.2026: Clear All emptied the totals but left the button enabled, same dead
	// "Add  to cart" state as above.
	document.querySelector('.js-quick-multibuy-submit').setAttribute('disabled', 'disabled');
}

document.getElementById('clearAll').addEventListener('click', clearQuickBuyGrid);

// ---------------------------------------------------------------------------
// 20.9.2026 - tap to add.
//
// The grid used to be bare number inputs. Customers could not tell the empty
// cells were fields at all, and on a phone typing into a 53px cell meant
// fighting the keyboard. Each cell is now a small box that adds one per tap,
// with a minus badge for the way back and a long press for typing a real
// number. The input is still the single source of truth - everything below
// goes through updateTotals(), so the running total, the Clear All link and
// the add button keep working exactly as they did.
// ---------------------------------------------------------------------------
(function () {
	var COARSE = window.matchMedia ? window.matchMedia('(pointer: coarse)').matches : false;

	function qbPaint(input) {
		var cell = input.closest('.qb-cell');
		if (!cell) { return; }
		if ((parseInt(input.value) || 0) > 0) {
			cell.classList.add('qb-cell--filled');
		} else {
			cell.classList.remove('qb-cell--filled');
		}
	}

	function qbShowSku(input) {
		// The stock handlers below do this without a guard. There is no product meta block
		// in the quick view modal, so guard it here.
		var el = document.querySelector('.product-meta__sku-number');
		var sku = input.getAttribute('data-variant-sku');
		if (el && sku) { el.innerText = sku; }
	}

	function qbSet(input, next) {
		var max = parseInt(input.getAttribute('data-max-quantity')) || 0;
		if (next > max) { next = max; }
		if (next < 0) { next = 0; }
		input.value = next === 0 ? '' : next;
		updateTotals(input);
		qbShowSku(input);
		qbPaint(input);
	}

	document.querySelectorAll('.js-quantity-selector__value').forEach(function (input) {
		var cell = input.closest('.qb-cell');
		if (!cell) { return; }

		// On a touch screen a tap must not open the keyboard - readonly is the one way to
		// focus an input without it. The long press below lifts it for as long as the
		// customer is actually typing.
		if (COARSE) { input.setAttribute('readonly', 'readonly'); }

		var pressTimer = null;

		function startPress() {
			if (!COARSE) { return; }
			pressTimer = setTimeout(function () {
				cell.classList.add('qb-cell--typing');
				input.removeAttribute('readonly');
				input.focus();
				input.select();
			}, 500);
		}

		function endPress() {
			if (pressTimer) { clearTimeout(pressTimer); pressTimer = null; }
		}

		cell.addEventListener('pointerdown', startPress);
		cell.addEventListener('pointerup', endPress);
		cell.addEventListener('pointerleave', endPress);
		cell.addEventListener('pointercancel', endPress);

		cell.addEventListener('click', function (event) {
			if (event.target.closest('.qb-step--minus')) { return; }
			// A long press just put the caret in this cell. Do not add on the click that
			// ends it, or the customer gets a 1 they did not ask for.
			if (cell.classList.contains('qb-cell--typing')) { return; }
			qbSet(input, (parseInt(input.value) || 0) + 1);
			// With a mouse, select what is there so the next keystroke replaces it rather
			// than appending to it.
			if (!COARSE) { input.focus(); input.select(); }
		});

		var minus = cell.querySelector('.qb-step--minus');
		if (minus) {
			minus.addEventListener('click', function (event) {
				event.preventDefault();
				event.stopPropagation();
				qbSet(input, (parseInt(input.value) || 0) - 1);
			});
		}

		// The theme's own handlers hang off change and keyup, which a paste, an autofill or a
		// phone keyboard can skip. input fires for all of them, and updateTotals reconciles
		// against data-old-quantity, so running it twice for one keystroke costs nothing.
		input.addEventListener('input', function () {
			updateTotals(input);
			qbShowSku(input);
			qbPaint(input);
		});

		input.addEventListener('blur', function () {
			cell.classList.remove('qb-cell--typing');
			if (COARSE) { input.setAttribute('readonly', 'readonly'); }
			qbPaint(input);
		});
	});
})();
